export default __webpack_public_path__ + "static/media/btn_big_purchasegmx.983b305a.svg";